import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import FiverrLogo from '@fiverr-private/fit/icons/logos/fiverr_logo_nav';
import { ABSOLUTE_ROOT_PATH } from '../../../../constants';
import styles from './style.module.scss';

const EducateHubLogo = () => (
  <a className={styles.logo} href={ABSOLUTE_ROOT_PATH}>
    <FiverrLogo />
    <span className={styles.label}>
      <b>
        <I18n k="fiverr_guides.header.logo_label" />
      </b>
    </span>
  </a>
);

export default EducateHubLogo;
